import { render, staticRenderFns } from "./CreateSundryItemOrderPopUp.vue?vue&type=template&id=90ef427a&scoped=true&"
import script from "./CreateSundryItemOrderPopUp.vue?vue&type=script&lang=js&"
export * from "./CreateSundryItemOrderPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateSundryItemOrderPopUp.vue?vue&type=style&index=0&id=90ef427a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ef427a",
  null
  
)

export default component.exports